<template>
    <div class="central-content__form-fields">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Fields"
};
</script>

<style lang="scss" scoped>
.central-content__form-fields {
    margin-bottom: 24px;
}

@media (max-width: 812px) {
    .central-content__form-fields {
        width: 90%;
    }
}
</style>
